<app-form-input [parentForm]="parentForm" [value]="natureMarche.intitule" [label]="step4.getintitule" [type]="'text'"
    [rule]="'required|minSize_5|maxSize_2000'" [errorMessage]="{'required' : 'ctr_1090_HorsDef', 'maxLength' : 'ctr_1091_HorsDef'}"
    [disabled]="disabled" [name]="getUid()+'_SepAtt_intitule'">
</app-form-input>
<!---->


<!---->

<app-type-objCPV [uid]="getUid()" [parentForm]="parentForm" [cpv]="natureMarche.codeCPV" [disabled]="disabled" ></app-type-objCPV>

<!---->

<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="radioButtonValue" [label]="step4.gettypemarche" [type]="'radio'"
[rule]="'required'"
[errorMessage]="{'required' : 'ctr_1094_HorsDef'}" [radios]="[
		{
			value: travauxValue,
			label: step4.gettravaux
		},
		{
			value: fournituresValue,
			label: step4.getfournitures
		},
		{
			value: servicesValue,
			label: step4.getservices
		}
	]" [name]="getUid()+'_SepAtt_natureMarche'">
</app-form-input>

<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="natureMarche.description" [label]="step4.getdescription"
    [type]="'text'" [rule]="'minSize_5|maxSize_2000'" [name]="getUid()+'_SepAtt_description'">
</app-form-input>
